import { useCallback, useRef } from "react";
import { useCloseAndBlur } from "@hooks/useCloseAndBlur";

/**
 * Encapsulates the stable ref-backed close callback shared by the NoteCell
 * components. `closeAndBlur` can be passed to `useNoteEditing` without a
 * circular dependency on `setIsOpened`; the caller registers the real close
 * handler via `setClose` after `useNoteEditing` returns.
 */
export const useNotePopoverClose = () => {
    const closeRef = useRef<() => void>(() => undefined);
    const closePopover = useCallback(() => closeRef.current(), []);
    const closeAndBlur = useCloseAndBlur(closePopover);

    const setClose = useCallback((close: () => void) => {
        closeRef.current = close;
    }, []);

    return { closeAndBlur, setClose };
};
